import React, { useEffect, useRef } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const CONTACT_LAST_NAME_SLUG = 'contact_last_name'

const ContactFirstName: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control, getValues, trigger } = useFormContext()
  const { t } = useTranslation()

  const self = getValues(name)
  const allFields = (getValues('fields') as any[]) || []
  const contactLastNameIndex = allFields.findIndex(
    f => f?.slug === CONTACT_LAST_NAME_SLUG && f?.category === self?.category && f?.farmerId === self?.farmerId
  )
  const contactLastNameValue = contactLastNameIndex >= 0 ? `fields[${contactLastNameIndex}].value` : undefined

  const ownValue = useWatch({ control, name: `${name}.value` })
  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    if (contactLastNameValue) trigger(contactLastNameValue)
  }, [ownValue])

  const required = !disabled && Boolean(field.fieldRequired)

  const rules = {
    ...(required && {
      required: {
        value: true,
        message: t('Please enter Contact first name')
      }
    }),
    validate: (value: string) => {
      if (disabled || value) return true
      const siblingValue = contactLastNameValue ? getValues(contactLastNameValue) : undefined
      if (siblingValue) {
        return t('Please enter Contact first name')
      }
      return true
    }
  }

  return (
    <FormFields.Input
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      rules={rules}
    />
  )
}

export default ContactFirstName
